var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var g0 = !_vm.hasBuy ? Number(_vm.item.charge / 100).toFixed(1) : null
  var g1 =
    !_vm.hasBuy && _vm.item.charge_original > 0
      ? Number(_vm.item.charge_original / 100).toFixed(1)
      : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        g0: g0,
        g1: g1,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }